import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../insightConfig/insightConfig';
import { Spinner } from 'react-bootstrap';
import { useAlert } from 'react-alert';

function VerifyEmail() {
    const [verifying, setVerifying] = useState(true);
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('Verifying your email...');
    const location = useLocation();
    const navigate = useNavigate();
    const alert = useAlert();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (!token) {
            setStatus('error');
            setMessage('Invalid verification link.');
            setVerifying(false);
            return;
        }

        const verifyToken = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/verify-email/${token}`);
                if (response.data.statusCode === 200) {
                    setStatus('success');
                    setMessage('Your email has been verified successfully!');
                    alert.show('Email verified successfully!');
                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                } else {
                    setStatus('error');
                    setMessage(response.data.message || 'Verification failed.');
                }
            } catch (error) {
                console.error('Error verifying email:', error);
                setStatus('error');
                setMessage('An error occurred during verification. The link may be expired.');
            } finally {
                setVerifying(false);
            }
        };

        verifyToken();
    }, [location, navigate, alert]);

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <div className="card shadow p-5 text-center" style={{ maxWidth: '500px', width: '100%', borderRadius: '15px' }}>
                {verifying ? (
                    <div>
                        <Spinner animation="border" variant="primary" className="mb-3" />
                        <h3>{message}</h3>
                    </div>
                ) : (
                    <div>
                        {status === 'success' ? (
                            <div className="text-success">
                                <i className="fa fa-check-circle fa-5x mb-3"></i>
                                <h2 className="fw-bold mb-3">Success!</h2>
                                <p className="fs-5">{message}</p>
                                <p className="text-muted">Redirecting to login page...</p>
                                <button className="btn btn-primary mt-3" onClick={() => navigate('/login')}>Go to Login</button>
                            </div>
                        ) : (
                            <div className="text-danger">
                                <i className="fa fa-times-circle fa-5x mb-3"></i>
                                <h2 className="fw-bold mb-3">Failed</h2>
                                <p className="fs-5">{message}</p>
                                <button className="btn btn-primary mt-3" onClick={() => navigate('/')}>Go to Home</button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default VerifyEmail;
